
import React, { useState } from 'react';

import { ReactComponent as SearchIcon } from '../../assets/icons/search-icon.svg';

// Filtro: testo + date-range
const RubricaFilterBar = ({ filterParams, onChange }) => {
    const { searchterm, dateRange } = filterParams;
    return (
        <div className="vista-filter-bar expand-on-focus">
            <div className="search-wrapper">
                <SearchIcon className="search-icon" />
                <input
                    type="text"
                    className="search"
                    name="searchterm"
                    placeholder="Ricerca per cognome, nome o numero di telefono"
                    value={searchterm}
                    onChange={e => onChange({ ...filterParams, searchterm: e.target.value })}
                />
            </div>
        </div>
    );
}
export default RubricaFilterBar;